import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";

import { cartActions } from "./cart.reducer";

import {
  getCart,
  addCartItems,
  clearCartItem,
  removeCartItem,
} from "../../apis/shop.services.apis";

// Fetch cart async
export function* fetchCartAsync(action: any) {
  try {
    const cartItems: any[] = yield call(getCart, action.payload);

    yield put(cartActions.fetchCartSuccess(cartItems));
  } catch (error) {
    yield put(cartActions.fetchCartFailure(error));
  }
}

export function* fetchCartStart() {
  yield takeLatest(cartActions.fetchCartStart.type, fetchCartAsync);
}

// Add item async
export function* addItemAsync(action: any) {
  let cartInfo = {
    hasTriedToAdd: false,
    isAddedSuccessfully: false,
  };

  try {
    yield call(addCartItems, action.payload);

    const cartInfoLocalStorage = localStorage.getItem("cartInfo");

    if (cartInfoLocalStorage) {
      cartInfo = { ...cartInfo, ...JSON.parse(cartInfoLocalStorage) };
    }

    cartInfo.hasTriedToAdd = true;
    cartInfo.isAddedSuccessfully = true;
    localStorage.setItem("cartInfo", JSON.stringify(cartInfo));

    const cartItems: any[] = yield call(getCart, action.payload.userId);

    yield put(cartActions.addItemSuccess(cartItems));

    localStorage.removeItem("cartItems");
  } catch (error) {
    const cartInfoLocalStorage = localStorage.getItem("cartInfo");

    if (cartInfoLocalStorage) {
      cartInfo = { ...cartInfo, ...JSON.parse(cartInfoLocalStorage) };
    }

    cartInfo.hasTriedToAdd = false;
    cartInfo.isAddedSuccessfully = false;
    localStorage.setItem("cartInfo", JSON.stringify(cartInfo));

    yield put(cartActions.addItemFailure(error));
  }
}

export function* addItemStart() {
  yield takeLatest(cartActions.addItemStart.type, addItemAsync);
}

// Clear item async
export function* clearItemAsync(action: any) {
  try {
    yield call(clearCartItem, action.payload);

    const cartItems: any[] = yield call(getCart, action.payload.userId);

    yield put(cartActions.clearItemSuccess(cartItems));
  } catch (error) {
    yield put(cartActions.clearItemFailure(error));
  }
}

export function* clearItemStart() {
  yield takeLatest(cartActions.clearItemStart.type, clearItemAsync);
}

// Remove item async
export function* removeItemAsync(action: any) {
  try {
    yield call(removeCartItem, action.payload);

    const cartItems: any[] = yield call(getCart, action.payload.userId);

    yield put(cartActions.removeItemSuccess(cartItems));
  } catch (error) {
    yield put(cartActions.removeItemFailure(error));
  }
}

export function* removeItemStart() {
  yield takeEvery(cartActions.removeItemStart.type, removeItemAsync);
}

export function* cartSagas() {
  yield all([
    call(fetchCartStart),
    call(addItemStart),
    call(clearItemStart),
    call(removeItemStart),
    // add more
  ]);
}
